import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

export const getDataBySelectorsArray = memoizeOne(dataSelectors =>
  createSelector(Object.values(dataSelectors), (...data) =>
    Object.keys(dataSelectors).reduce(
      (acc, key, index) => ({
        ...acc,
        [key]: data[index],
      }),
      {},
    ),
  ),
);
